import React from 'react';
import {Tbody} from '@tempo/core';
import ArtistDiscographyTableRow from './ArtistDiscographyTableRow';
import type {Release} from '@deezer/next/services/api/Starmania/requests/album/types';

type ArtistDiscographyTableBodyProps = {
	selectedReleaseIds: number[];
	lockedReleaseIdSet: ReadonlySet<number>;
	data: Release[];
	onChange: (id: number) => void;
};

const ArtistDiscographyTableBody = ({
	data,
	selectedReleaseIds,
	lockedReleaseIdSet,
	onChange,
}: ArtistDiscographyTableBodyProps) => {
	return (
		<Tbody>
			{data.map((release, rowIndex) => (
				<ArtistDiscographyTableRow
					key={release.id}
					isRowSelected={selectedReleaseIds.includes(release.id)}
					isRowLocked={lockedReleaseIdSet.has(release.id)}
					rowIndex={rowIndex}
					release={release}
					onRowChange={onChange}
				/>
			))}
		</Tbody>
	);
};

export default ArtistDiscographyTableBody;
